<template>
    <div class="input-group input-search-projects bg-white">
        <vue-google-autocomplete id="input-search" classname="form-control" placeholder="¿Donde te gustaría vivir?"
            :country="'cl'" types="(regions)" v-on:placechanged="getAddressData" v-on:keypress="searchGoogleMaps">
        </vue-google-autocomplete>
        <div class="input-group-append">
            <button class="px-3" type="button" id="button-addon2">
                <i class="fas fa-search text-white bg-color-palette-2 p-2" style="border-radius: 20px;"></i>
            </button>
        </div>
    </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
    name: "InputSearchProjects",
    components: {
        VueGoogleAutocomplete
    },
    props: ['promotions'],
    data() {
        return {
            address: '',
        }
    },
    methods: {
        /**
        * When the location found
        * @param {Object} addressData Data of the found location
        * @param {Object} placeResultData PlaceResult object
        * @param {String} id Input container ID
        */
        getAddressData(addressData, placeResultData) {
            const paramPromotions = this.promotions ? 'proyectos-promociones/' : ''
            const url = `/proyectos/${paramPromotions}${placeResultData.address_components[0].long_name}`
            top.location.href = url;
        },
        handleError(error) {
            console.log(error);
        },
        async searchGoogleMaps(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                const firstResult = $(".pac-container .pac-item:first").text();
                if (firstResult == null || firstResult == '') {
                    return;
                }

                var geocoder = new google.maps.Geocoder();
                let addressValid = false;
                let addressresults = [];
                await geocoder.geocode({ "address": firstResult }, function (results, status) {
                    if (status == 'OK') {
                        addressValid = true;
                        addressresults = results;
                    }
                });

                if (addressValid) {
                    this.getAddressData(null, addressresults[0]);
                }
            }
        }
    }
}
</script>

<style>
#input-search {
    height: 3rem;
    border-radius: 40px;
    border: 0;
    z-index: 10;
}

#input-search:focus {
    box-shadow: none;
}
</style>